export const isLocalEnvironment = document.location.host === 'localhost:3000';

export const isTestEnvironmentInlife = document.location.host === 'splk-test.russianitgroup.ru' || document.location.host === 'sp-test.russianitgroup.ru';

export const isTestEnvironmentSCBInside = document.location.host === 'seller-sk-test.sovcombank.group';

export const isTestEnvironment = isTestEnvironmentInlife || isTestEnvironmentSCBInside;

export const isProdEnvironmentInlife = document.location.host === 'seller.in-life.ru';

export const isProdEnvironmentSCB = document.location.host === 'seller.sovcomlife.ru';

export const isProdEnvironmentSCBInside = document.location.host === 'seller.uvp-sk-web-app1.sovcombank.group';

export const isProdEnvironment = isProdEnvironmentInlife || isProdEnvironmentSCB || isProdEnvironmentSCBInside;

export const sanitizeText = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);
